import React from "react";

const CloseBtnIcon = () => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 18.4922C14.4706 18.4922 18.5 14.4628 18.5 9.49219C18.5 4.52162 14.4706 0.492188 9.5 0.492188C4.52944 0.492188 0.5 4.52162 0.5 9.49219C0.5 14.4628 4.52944 18.4922 9.5 18.4922Z"
        fill="#E8E8E8"
      />
      <path
        d="M11.75 7.24219L7.25 11.7422M7.25 7.24219L11.75 11.7422"
        stroke="#333333"
        stroke-width="0.952941"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default CloseBtnIcon;
